import React, {useRef, useState} from "react";
import axios from "axios";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import { Box, Button, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import KeyPicker from "../Vehicle/KeyPicker";
import Inspections from "./Inspections";


function VehicleJobSection({
                             handleVehicleChange,
                             vehicleUpdate,
                             endpoint,
                             vehicle,
                             history,
                             type,
                             disabled,
                             keys,
                             onKeyClear,
                             onInspectionAdd,
                             attached_inspections,
                             isDefect=false
                           }) {
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const typeahead = useRef();

  const handleChange = e => {
    vehicle[e.target.name] = e.target.value;
    handleVehicleChange(vehicle);
  };

  const handleContinue = vehicle => {
    typeahead.current.clear();
    vehicleUpdate(vehicle);
  };
  let keyObjects;
  if (type === "Job Card"){
    keyObjects = keys.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});
  }

  const handleKeyChange = (e) => {
    vehicle.key = keyObjects[e.target.value];
    vehicleUpdate(vehicle);
  }
  const diffDates = (date1, date2) => {
    const dayDiff = (date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24);
    return dayDiff;
  }
  const warrantyExpire = (date) => {
    const today = new Date();
    const dateToCheck = new Date(date);

    const diff = diffDates(dateToCheck, today)

    if (date == null) {
      return ""
    } else if (diff < 1) {
      return "danger"
    } else if (diff <= 30) {
      return "warning"
    } else {
      return "success"
    }
  }


  const handleVehicleSelect = e => {
    handleContinue(e[0]);
  };

  const handleSearch = query => {
    setLoading(true);
    let url = endpoint + `vehiclesearch?search=${query}`;
    axios.get(url).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleVehicleType = customerVehicle => {
    const newVehicle = {vehicle_status: customerVehicle};
    handleVehicleChange(newVehicle);
  };

  return (
    <Box className="top-spacing">
      <h1 className="title">Vehicle</h1>
      {!disabled &&
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  data-testid="vehicle-search"
                  id="typeahead"
                  labelKey="registration"
                  minLength={2}
                  name={"registration"}
                  onSearch={handleSearch}
                  onChange={handleVehicleSelect}
                  placeholder={"Search Vehicle Registration"}
                  options={searchData}
                  ref={typeahead}
                  className="registration-ui"
                  isLoading={isLoading}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Button
              tabIndex={-1}
              onClick={() => window.open("/editvehicle", "_blank")}
              color="success"
              className="is-pulled-right"
            >
              Add a new Vehicle +
            </Button>
          </Column>
        </Columns>
      }

      <Column>
      <Field>
        <label className="label label">Registration</label>
        <Control className="registration-wrapper">
          <Input
            className="registration-field"
            type="text"
            data-testid={"vehicle_reg"}
            name="registration"
            onChange={handleChange}
            value={vehicle.registration}
            required
            disabled={true}
          />
        </Control>
      </Field>
      {vehicle.id &&
        <Button tabIndex={-1} color="info" onClick={() => window.open(`/editvehicle/${vehicle.id}`, "_blank")}>Vehicle
          Details</Button>
      }
      </Column>
      <Columns isMultiline>
        <Column>
          <Columns isMultiline>
            <Column>
              <Field>
                <Control>
                  <label className="label">Make</label>
                  <Input
                    type="text"
                    name="make"
                    onChange={handleChange}
                    data-testid={"make"}
                    value={vehicle.make ? vehicle.make.name : ""}
                    required
                    readOnly={true}
                    disabled={true}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Model</label>
                <Input
                  type="text"
                  name="model"
                  onChange={handleChange}
                  data-testid={"model"}
                  value={vehicle.model ? vehicle.model.name : ""}
                  required
                  readOnly={true}
                  disabled={true}
                />
              </Field>
            </Column>
            <Column>
              <Field>
                <Control>
                  <label className="label">Variant</label>
                  <Input
                    type="text"
                    name="variant"
                    onChange={handleChange}
                    data-testid={"variant"}
                    value={vehicle.variant}
                    required
                    readOnly={true}
                    disabled={true}
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <Control>
                  <label className="label">Mileage</label>
                    <Input
                      type="number"
                      name="mileage"
                      onChange={handleChange}
                      data-testid={"mileage"}
                      value={String(vehicle.mileage)}
                      required
                      readOnly={true}
                      disabled={true}
                    />
                  </Control>
                </Field>
            </Column>
            {type === "Job Card" &&
            <Column>
              <Field>
                <Control>
                  <label className="label">Current Key</label>
                  <Input
                    readOnly={true}
                    disabled={true}
                    data-testid={"vehicle-current-key"}
                    value={vehicle.key ? vehicle.key.key_number : ""}
                  />
                </Control>
              </Field>
            </Column>
            }
            {type === "Job Card" &&
            <Column>
              <KeyPicker
                keys={keys}
                onKeyChange={handleKeyChange}
                selectedKey={vehicle.key ? vehicle.key.id : null}
                disabled={isDefect}
                onClear={onKeyClear}
              />
            </Column>
            }
          </Columns>
          <Field>
            <Control>
              <label className="label">Vehicle Status</label>
              <Input
                type="text"
                name="vehicle_status"
                value={vehicle.vehicle_status}
                required
                readOnly={true}
                disabled={true}
              />
            </Control>
          </Field>
          {vehicle.owner &&
              <Field>
                <Control>
                  <label className="label">Customer Owner</label>
                  <Input
                    type="text"
                    name="customer_owner"
                    value={vehicle.owner.display_name}
                    required
                    readOnly={true}
                    disabled={true}
                  />
                </Control>
              </Field>
          }
          {vehicle.hire_customer &&
            <Field>
                <Control>
                  <label className="label">Hire Customer</label>
                  <Input
                    type="text"
                    name="hire_customer"
                    value={vehicle.hire_customer.display_name}
                    required
                    readOnly={true}
                    disabled={true}
                  />
                </Control>
            </Field>
          }
        </Column>
        <Column>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">LCV Sold</label>
                <input
                  className="checkbox"
                  type="checkbox"
                  name="lcv_sold"
                  readOnly={true}
                  checked={vehicle.lcv_sold}
                />
              </Field>
            </Column>
            <Column>
              <label className="label">Vehicle Location</label>
              <Input
                value={vehicle.location}
                readOnly={true}
                disabled={true}
                name={"vehicle_location"}
                type={"text"}
                data-testid={"vehicle-location"}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Manufacturer Warranty End Date</label>
                <Input
                  type="date"
                  name="manufacturer_main_warranty_date"
                  value={vehicle.manufacturer_main_warranty_date}
                  required
                  readOnly={true}
                  disabled={true}
                  data-testid={"manufacturer-warranty-end-date"}
                  color={warrantyExpire(vehicle.manufacturer_main_warranty_date)}
                  textColor={warrantyExpire(vehicle.manufacturer_main_warranty_date)}
                  textWeight={warrantyExpire(vehicle.manufacturer_main_warranty_date) === "warning" ? "bold" : ""}
                />
              </Field>
            </Column>
            <Column>
              <label className="label">Manufacturer Warranty Supplier</label>
              <Input
                type="text"
                name="manufacturer_main_warranty_workshop"
                value={vehicle.manufacturer_main_warranty_workshop ? vehicle.manufacturer_main_warranty_workshop.display_name : ""}
                required
                readOnly={true}
                disabled={true}
                color={warrantyExpire(vehicle.manufacturer_main_warranty_date)}
                textColor={warrantyExpire(vehicle.manufacturer_main_warranty_date)}
                textWeight={warrantyExpire(vehicle.manufacturer_main_warranty_date) === "warning" ? "bold" : ""}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Driveline Warranty End Date</label>
                <Input
                  type="date"
                  name="driveline_warranty_date"
                  value={vehicle.driveline_warranty_date}
                  required
                  readOnly={true}
                  disabled={true}
                  data-testid={"driveline-warranty-end-date"}
                  color={warrantyExpire(vehicle.driveline_warranty_date)}
                  textColor={warrantyExpire(vehicle.driveline_warranty_date)}
                  textWeight={warrantyExpire(vehicle.driveline_warranty_date) === "warning" ? "bold" : ""}
                />
              </Field>
            </Column>
            <Column>
              <label className="label">Driveline Warranty Supplier</label>
              <Input
                type="text"
                name="driveline_warranty_workshop"
                value={vehicle.driveline_warranty_workshop ? vehicle.driveline_warranty_workshop.display_name : ""}
                required
                readOnly={true}
                disabled={true}
                color={warrantyExpire(vehicle.driveline_warranty_date)}
                textColor={warrantyExpire(vehicle.driveline_warranty_date)}
                textWeight={warrantyExpire(vehicle.driveline_warranty_date) === "warning" ? "bold" : ""}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Aftermarket Warranty End Date</label>
                <Input
                  type="date"
                  name="aftermarket_warranty_date"
                  value={vehicle.aftermarket_warranty_date}
                  required
                  readOnly={true}
                  disabled={true}
                  data-testid={"aftermarket-warranty-end-date"}
                  color={warrantyExpire(vehicle.aftermarket_warranty_date)}
                  textColor={warrantyExpire(vehicle.aftermarket_warranty_date)}
                  textWeight={warrantyExpire(vehicle.aftermarket_warranty_date) === "warning" ? "bold" : ""}
                />
              </Field>
            </Column>
            <Column>
              <label className="label">Aftermarket Warranty Supplier</label>
              <Input
                type="text"
                name="aftermarket_warranty_workshop"
                value={vehicle.aftermarket_warranty_workshop ? vehicle.aftermarket_warranty_workshop.display_name : ""}
                required
                readOnly={true}
                disabled={true}
                color={warrantyExpire(vehicle.aftermarket_warranty_date)}
                textColor={warrantyExpire(vehicle.aftermarket_warranty_date)}
                textWeight={warrantyExpire(vehicle.aftermarket_warranty_date) === "warning" ? "bold" : ""}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">R & M Warranty End Date</label>
                <Input
                  type="date"
                  name="rm_warranty_date"
                  value={vehicle.rm_warranty_date}
                  required
                  readOnly={true}
                  disabled={true}
                  data-testid={"rm-warranty-end-date"}
                  color={warrantyExpire(vehicle.rm_warranty_date)}
                  textColor={warrantyExpire(vehicle.rm_warranty_date)}
                  textWeight={warrantyExpire(vehicle.rm_warranty_date) === "warning" ? "bold" : ""}
                />
              </Field>
            </Column>
            <Column>
              <label className="label">R & M Warranty Supplier</label>
              <Input
                type="text"
                name="rm_warranty_workshop"
                value={vehicle.rm_warranty_workshop ? vehicle.rm_warranty_workshop.display_name : ""}
                required
                readOnly={true}
                disabled={true}
                color={warrantyExpire(vehicle.rm_warranty_date)}
                textColor={warrantyExpire(vehicle.rm_warranty_date)}
                textWeight={warrantyExpire(vehicle.rm_warranty_date) === "warning" ? "bold" : ""}
              />
            </Column>
          </Columns>
        </Column>
        <Column>
          <Title size="4">Inspections</Title>
          <Inspections vehicle={vehicle} onInspectionAdd={onInspectionAdd} attached_inspections={attached_inspections} type={type}/>
        </Column>
      </Columns>
    </Box>
  );
}

export default VehicleJobSection;
